import api from '@/api/api';

const DOMAIN = '/match';

/** Público: perguntas do match (não exige login). */
const getForm = async (): Promise<Match.Form> => {
	const { data } = await api.get(`${DOMAIN}/form`);
	return data;
};

/** Usuário logado: se já respondeu, devolve o resultado. */
const getMine = async (): Promise<Match.MyMatch> => {
	const { data } = await api.get(`${DOMAIN}/me`);
	return data;
};

/** Usuário logado: envia respostas (1x por conta) e recebe os 3 profissionais. */
const submitAnswer = async (
	body: Match.SubmitAnswer,
): Promise<Match.Result> => {
	const { data } = await api.post(`${DOMAIN}/answers`, body);
	return data;
};

/** Admin: simula o match (não salva nada) e devolve todos os psicólogos com a nota. */
const simulate = async (
	body: Match.SubmitAnswer,
): Promise<Match.Simulation> => {
	const { data } = await api.post(`${DOMAIN}/simulate`, body);
	return data;
};

const MatchService = { getForm, getMine, submitAnswer, simulate };

export { MatchService };
